export default ({
  namespaced: true,
  state: {
    view: 'companyUserParams',
    values: {},
    loaded: false
  },
  getters: {
    state: state => {
      return state
    },
    values: state => {
      return state.values
    },
    loaded: state => {
      return state.loaded
    }
  },
  mutations: {
    change_values (state, payload) {
      state.loaded = true
      // Object.assign(state.values, payload)
      state.values = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/companyUserParams.js